import { Alert } from '@mui/material';

export const ErrorBanner = ({ errorMessage }) => {
  return errorMessage ? (
    <Alert severity={'error'} sx={{ marginBottom: '1rem' }}>
      {errorMessage}
    </Alert>
  ) : (
    <></>
  );
};
